import querystring from "query-string";

const resetPasswordEmailCodeSelector = (
    state: sage.state.IRedux
): { email: string; code: string } | null => {
    const params = querystring.parse(state.router.location.search);
    if (params.code && params.email) {
        return {
            code: params.code as string,
            email: params.email as string,
        };
    } else {
        return null;
    }
};

export default resetPasswordEmailCodeSelector;
